import React, { useEffect, useContext,  useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import ValueContext from "../../utils/contextAPI/contextAPI";
import InfoIcon from '../../images/InfoIconGray.svg';
import SharedThumbImage from "./SharedThumbImage";
import SharedImage from "./SharedImage";
import SharedFontUpload from "./SharedFontUpload";
 import {clearSharedResources, updateDeckInfo, getSharedFileFromTemp, geteDetailByID} from "../../services/apis"

import './SharedResource.scss';
import { ErrorCode } from "react-dropzone";


const SharedResource = ({isOpenSharedModal,setOpenSharedResource,deckIdCurrent,modeFrom,sourceDeckId, editor }) => {
 
    const fontlist = editor?.StyleManager?.getProperty("typography", "font-family")||[];
    const appData = useContext(ValueContext);
    const navigate = useNavigate();

    const [allFonts, setAllFonts] = useState([]);
    const [allImages, setAllImages] = useState([]);
    const [allThumb, setAllThumb] = useState([]);
    const [deletedFont, setDeletedFont] = useState([]);
    const [defaultFont, setDefaultFont] = useState([...fontlist?.attributes?.list || []]);

    useEffect(()=>{
      //  existingSharedFromSource();
    },[]);

    const existingSharedFromSource =()=>{
        if(sourceDeckId){
            const payload={deckId : deckIdCurrent._id , templateId : sourceDeckId};
             getSharedFileFromTemp(payload, (response, err, ErrorCode) => {
                if (err) { } else {
                     console.log('=======response=======', response)
                 }
             }) 
        }
    }
    const clearAll = ()=> {
        clearSharedResources(deckIdCurrent._id,(response, err, ErrorCode)=>{
            if (err) {
                // toast.error(`upload failed`);                
            } else {
                setOpenSharedResource(false);
            }
        })
    }

    const backHandler = () => {
        setOpenSharedResource(false);
    }

    const proceedHandler = ()=> {

       
    //    // console.log('deck data', deckIdCurrent)
    if (modeFrom!=='Edit')
        navigate(`/editor/${deckIdCurrent?.slides[0]?.slideid._id}`);
    
        const currentDeckData = deckIdCurrent;
        currentDeckData.deck_shared_assets = {fonts: allFonts, thumb: allThumb, images: allImages}

        updateDeckInfo(deckIdCurrent._id, currentDeckData, (response, err, ErrorCode)=>{           
          if(editor) {
           // editor.CssComposer.clear();
                const cssString = editor.getCss();
                const existingFontUrls = new Set(
                    [...cssString.matchAll(/@font-face\s*\{[^}]*src\s*:\s*url\(["']?([^"')]+)["']?\)[^}]*\}/gi)]
                        .map((match) => match[1])
                );
                const uniqueFonts = allFonts.filter((font, index, self) => {
                    const fontUrl = font?.link;
                    return fontUrl && self.findIndex((item) => item?.link === fontUrl) === index;
                });

                uniqueFonts.forEach((font) => {
                    const fontUrl = font?.link;
                    if (!fontUrl || existingFontUrls.has(fontUrl)) {
                        return;
                    }

                    const fontCss = `@font-face{font-family: "${font?.name?.split('.')[0]}";src:url("${fontUrl}");}`;
                    editor.Css.addRules(fontCss);
                    existingFontUrls.add(fontUrl);
                });
                
                if (deletedFont.length > 0) {
                    let finalCss = editor.getCss();
                    deletedFont.forEach((list) => {
                        const removeCss = `@font-face{font-family:${list?.name?.split('.')[0]};src:url("${list?.link}");}`;
                        finalCss = finalCss.replaceAll(removeCss, ' ');
                    })
                    editor.CssComposer.clear();
                    editor.Css.addRules(finalCss);
                }
                fontlist.set("options",defaultFont);
            }
            setOpenSharedResource(false);
        })
   
    }
    return (
        <div>
             <Modal
                show={isOpenSharedModal}
                fullWidth={true}
                size="lg"
                centered
                className="shared-image-modal"
            >
                <Modal.Header className="shared-image-modal-header d-flex align-items-center ">
                    <div className="">
                        <Modal.Title className="shared-image-modal-header-title_1">{modeFrom ==='Edit'?'Edit Shared Resources':'Add Shared Resources'}</Modal.Title>
                        <div className="d-flex align-items-center">
                            <img className="shared-image-modal-image" src={InfoIcon} alt="" width={12} height={12}/>
                            <h3 className="shared-image-modal-header-title_2">Upload required resource files.</h3>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="shared-image-modal-body">
                    <div className="d-flex shared-image-modal-content">
                        <SharedThumbImage setAllThumb={setAllThumb} deckData={deckIdCurrent}  deckId={deckIdCurrent?._id}/>
                        <SharedImage editor={editor} setAllImages={setAllImages} deckData={deckIdCurrent} deckId={deckIdCurrent?._id}/>
                        <SharedFontUpload defaultFont={defaultFont} setDefaultFont={setDefaultFont} setAllFonts={setAllFonts} deckData={deckIdCurrent} deckId={deckIdCurrent?._id} setDeletedFont={setDeletedFont} deletedFont={deletedFont} />
                    </div>
                </Modal.Body>
                <Modal.Footer className="shared-modal-footer">
                    <div className="shared-modal-footer-content">
                        <div><Button className="shared-modal-back" style={{visibility:modeFrom ==='Edit'?'hidden':'hidden'}} onClick={backHandler}>BACK</Button></div>
                        <div> {/* <Button className="shared-modal-cancel" style={{visibility:modeFrom ==='Edit'?'visible':'hidden'}} onClick={clearAll}>CANCEL</Button> */}
                            <Button className="shared-modal-next" onClick={proceedHandler}>{modeFrom === 'Edit' ? ' Go To Editor' : 'CREATE TEMPLATE'}</Button>
                            </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default SharedResource;